<template>
  <div class="switcher">
    <p
      v-for="locale in locales"
      :key="locale.code"
      @click="switchLocale(locale.code)"
      class="switcher__item"
      :class="[{ active: currentLocale.code === locale.code }]"
    >
      {{ locale.name }}
    </p>
  </div>
</template>

<script setup>
import {Languages} from "@/core/api/languages.js";
import translation from "@/core/helpers/translations.js";
import {onMounted, ref, watch} from "vue";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";

const route = useRoute()
const router = useRouter()

const locales = ref([])
const currentLocale = ref(null)

const isSwitcherVisible = ref(false)
const setSwitcherVisible = (state) => {
  isSwitcherVisible.value = state
}

const getLanguages = async () => {
  const res = await Languages.getLanguages()
  locales.value = res.data.languages.filter((locale) => translation.supportedLocales.includes(locale.code));
  currentLocale.value = locales.value.find((locale) => locale.code === translation.currentLocale)
}

const switchLocale = async (newLocale) => {
  setSwitcherVisible(false)
  translations.switchLanguage(newLocale)
  await router.push({
    name: route.name,
    params: {
      ...route.params,
      locale: newLocale
    },
    query: { ...route.query }
  })
}

watch (
    () => translation.currentLocale,
    () => {
      currentLocale.value = locales.value.find((locale) => locale.code === localStorage.getItem('awe-user-locale'))
    }
)
onMounted(async () => {
  await getLanguages()
})
</script>

<style lang="scss" scoped>
.switcher {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__item {
    cursor: pointer;
    transition: 0.2s;
    color: $white;
    font-size: 16px;

    @include hover {
      color: #c5c5c5;
    }

    &.active {
      color: #FF0000;
    }
  }
}

@media (max-width: 600px) {
  .switcher {
    align-items: center;
  }
}
</style>